const Links = () => {
    return (
        <div className="links">
          <div className="link">
            <a href="mailto:jamescollin.jones.jcj@gmail.com" target="_blank" rel="noopener noreferrer">
            <img className="email" src="../images/email.png" alt="email"/>
          </a>
          </div>
          <div className="link">
            <a href="https://www.linkedin.com/in/j-collin-jones/" target="_blank" rel="noopener noreferrer">
            <img className="linkedin" src="../images/linkedin.svg" alt="linkedin logo"/>
          </a>
          </div>
          <div className="link">
            <a href="https://github.com/JCollinJones25" target="_blank" rel="noopener noreferrer">
            <img className="github" src="../images/github.svg" alt="github logo"/>
            </a>
          </div>
        </div>
    )
}

export default Links